import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";

import ColourContext from "../../contexts/ColourContext";
import { colourThemes } from "../../styles/colourPalettes";

import styles from "./AreaIcon.module.css";

type Value = {
  title: string;
  icon: string;
};

type LifeAreaIconProps = {
  area: Value;
  style?: React.CSSProperties;
  showLabel?: boolean;
  isHighlighted?: boolean;
  disabled?: boolean;
  onTap?: any;
  rotate?: number;
};

const AreaIcon = ({
  area,
  style,
  showLabel = false,
  isHighlighted,
  disabled,
  onTap,
  rotate,
}: LifeAreaIconProps) => {
  const { key: colourKey } = useContext(ColourContext);
  const colour = colourThemes[colourKey];

  return (
    <motion.div
      // id={`value-${area.title}`}
      key={`value-${area.title}-key`}
      // layoutId={`value-${area.title}`}w
      className={styles.container}
      animate={{ scale: isHighlighted ? 1.2 : 1 }}
      role="button"
      style={{
        ...style,
        cursor: disabled ? "initial" : "pointer",
        borderColor: isHighlighted ? colour : "#fff",
        marginTop: showLabel ? 24 : 0,
      }}
      onTap={!disabled ? onTap : () => {}}
    >
      {showLabel ? (
        <label style={{ opacity: isHighlighted ? 1 : 0.4 }}>{area.title}</label>
      ) : null}
      <span>{area.icon}</span>
    </motion.div>
  );
};

export default AreaIcon;
